import { useState } from 'react';

export default function ExtraInfo({ onSubmit }: { onSubmit: () => void }) {
  const [note, setNote] = useState('');
  const adminNote = 'Profilinizde eksik olan belge/sertifika bilgilerinin tamamlanması gerekmektedir. Lütfen sertifika veya diploma yükleyin.';

  return (
    <div className="w-full max-w-lg mx-auto">
      <div className="bg-white rounded-2xl border border-gray-100 shadow-soft p-6 md:p-10">
        <div className="text-center mb-6">
          <div className="w-14 h-14 rounded-full bg-soft-gold-50 flex items-center justify-center mx-auto mb-4">
            <i className="ri-message-3-line text-soft-gold-600 text-2xl" />
          </div>
          <h1 className="text-xl md:text-2xl font-bold text-deep-navy-500 mb-2">
            Ek bilgi gerekiyor
          </h1>
          <p className="text-sm text-gray-500 leading-relaxed max-w-sm mx-auto">
            Admin ekibimiz profilinizi tamamlamak için sizden ek bilgi talep etti.
          </p>
        </div>

        <div className="p-4 rounded-xl bg-off-white border border-gray-100 mb-6">
          <div className="flex items-start gap-3">
            <div className="w-8 h-8 rounded-full bg-dark-teal-500 flex items-center justify-center shrink-0">
              <i className="ri-user-star-line text-white text-sm" />
            </div>
            <div>
              <p className="text-xs font-semibold text-deep-navy-500 mb-1">Admin Ekibi</p>
              <p className="text-sm text-gray-500 leading-relaxed">{adminNote}</p>
            </div>
          </div>
        </div>

        <div className="mb-6">
          <label className="block text-sm font-medium text-deep-navy-400 mb-2">Yanıtınız</label>
          <textarea
            value={note}
            onChange={(e) => setNote(e.target.value)}
            placeholder="Admin ekibinin talebine yanıtınızı yazın..."
            rows={4}
            maxLength={500}
            className="w-full px-4 py-3 rounded-xl border border-gray-200 text-sm text-deep-navy-500 placeholder:text-gray-300 focus:outline-none focus:border-dark-teal-300 transition-colors resize-none"
          />
          <p className="text-xs text-gray-400 mt-1 text-right">{note.length}/500</p>
        </div>

        <button
          onClick={onSubmit}
          className="w-full py-3.5 rounded-full text-sm font-semibold text-white bg-dark-teal-500 hover:bg-dark-teal-600 transition-colors cursor-pointer"
        >
          Bilgileri Güncelle
        </button>
      </div>
    </div>
  );
}